import { jsx as s, jsxs as y, Fragment as j } from "react/jsx-runtime";
import { createElement as h, useRef as A, useState as k, useEffect as b, createContext as N, useContext as R } from "react";
import { withManagedProps as w } from "@made-people/managed-props";
import { withZod as T } from "@made-people/react-prop-guard";
import { textBlockBlueprint as g } from "./index-blueprint.es.js";
import { ButtonAsLink as O, buttonAsLinkSchema as H } from "@made-people/blueprint-button";
import { z as r } from "zod";
import { componentWrapperLayoutSchema as W, componentWrapperSchema as z, ComponentWrapper as _ } from "@made-people/blueprint-component-wrapper";
import { useTranslate as I } from "@made-people/grease-translations";
import { Markdown as E } from "@made-people/blueprint-markdown";
import { LinkAsLink as F, linkAsLinkSchema as M } from "@made-people/blueprint-link";
import { Heading as P, headingSchema as Z } from "@made-people/blueprint-heading";
import $ from "clsx";
import "@made-people/blueprint";
const q = () => {
  const { enableTruncate: e, isTruncated: t, setIsTruncated: n, shouldTruncate: o, slots: c } = d(), i = I();
  if (!e || !o)
    return null;
  const a = i(t ? "Text_Block_Read_More" : "Text_Block_Read_Less");
  return /* @__PURE__ */ s(
    "button",
    {
      className: c.truncateButton,
      onClick: () => n(!t),
      children: a
    }
  );
}, x = () => {
  const { body: e, slots: t, contentRef: n, truncateStyleObject: o } = d();
  return !e || e === "<p> </p>" ? null : /* @__PURE__ */ y(j, { children: [
    /* @__PURE__ */ s("div", { className: t.body, ref: n, style: o, children: /* @__PURE__ */ s(E, { content: e }) }),
    /* @__PURE__ */ s(q, {})
  ] });
}, B = () => {
  const { slots: e, ctas: t, ctaComponents: n } = d();
  return t != null && t.length ? /* @__PURE__ */ s("div", { className: e.ctaWrapper, children: t.map((o, c) => {
    if (o.component === "ButtonAsLink")
      return /* @__PURE__ */ h(O, { ...o, key: c });
    if (o.component === "LinkAsLink")
      return /* @__PURE__ */ h(F, { ...o, key: c });
    const i = o.component ? n == null ? void 0 : n[o.component] : void 0;
    return i ? /* @__PURE__ */ h(i, { ...o, key: c }) : null;
  }) }) : null;
}, v = () => {
  var n;
  const { slots: e, heading: t } = d();
  return !t || !t.lead && !((n = t.badge) != null && n.label) && !t.heading && !t.eyebrow ? null : /* @__PURE__ */ s(P, { className: e.headingWrapper, ...t });
}, D = (e, t) => {
  const n = A(null), [o, c] = k(!0), [i, a] = k(!0), m = () => {
    if (typeof t == "number" && n.current) {
      const l = n.current, p = window.getComputedStyle(l);
      let u = parseFloat(p.lineHeight);
      isNaN(u) && (u = parseFloat(p.fontSize) * 1.2);
      const f = u * t;
      c(l.scrollHeight > f);
    }
  };
  return b(() => {
    m();
  }, [e, t]), b(() => {
    a(!0);
  }, [e, t, o]), b(() => {
    if (!n.current)
      return;
    const l = new ResizeObserver(() => {
      m();
    });
    return l.observe(n.current), () => {
      l.disconnect();
    };
  }, [e, t]), {
    ref: n,
    shouldTruncate: o,
    isTruncated: o ? i : !1,
    setIsTruncated: a,
    truncateStyleObject: {
      display: "-webkit-box",
      WebkitLineClamp: i ? t : void 0,
      WebkitBoxOrient: "vertical",
      overflow: "hidden"
    }
  };
}, S = r.object({
  layout: W.optional(),
  variants: r.custom().optional(),
  alignContent: r.enum(["left", "center", "right"]).optional(),
  heading: Z.optional(),
  body: r.string().optional(),
  ctas: r.array(
    H.extend({
      component: r.literal("ButtonAsLink").optional()
    }).or(
      M.extend({
        component: r.literal("LinkAsLink").optional()
      })
    ).or(r.object({ component: r.string() }).passthrough())
  ).optional(),
  ctaComponents: r.custom().optional(),
  scrollToId: r.string().optional(),
  id: r.string().optional(),
  enableTruncate: r.boolean().optional(),
  truncateRows: r.number().optional(),
  visibility: z.shape.visibility.optional(),
  className: r.string().optional(),
  children: r.custom().optional()
}), L = N(null), d = () => {
  const e = R(L);
  if (!e)
    throw new Error("TextBlock components must be used within TextBlock");
  return e;
}, G = T(S, (e) => {
  const t = g.styles(e.variants);
  return /* @__PURE__ */ s(C, { ...e, children: /* @__PURE__ */ y(
    _,
    {
      layout: { ...e.layout },
      visibility: e.visibility,
      className: $(t.base, e.className),
      id: e.id,
      children: [
        /* @__PURE__ */ s(v, {}),
        /* @__PURE__ */ s(x, {}),
        /* @__PURE__ */ s(B, {})
      ]
    }
  ) });
}), C = T(
  S,
  ({
    variants: e,
    scrollToId: t,
    children: n,
    enableTruncate: o,
    truncateRows: c,
    ...i
  }) => {
    const a = g.styles(e), {
      shouldTruncate: m,
      ref: l,
      isTruncated: p,
      setIsTruncated: u,
      truncateStyleObject: f
    } = D(i.body, c ?? 2);
    return /* @__PURE__ */ s(
      L.Provider,
      {
        value: {
          ...i,
          slots: a,
          isTruncated: p,
          contentRef: l,
          setIsTruncated: u,
          truncateRows: c ?? 2,
          enableTruncate: o,
          shouldTruncate: m,
          scrollToId: t,
          truncateStyleObject: o ? f : {}
        },
        children: n
      }
    );
  }
), lt = Object.assign(
  w("TextBlock", G),
  {
    Heading: v,
    Body: x,
    Ctas: B,
    Root: C
  }
);
export {
  x as Body,
  B as CallToActions,
  v as Heading,
  lt as TextBlock,
  q as TruncateButton,
  S as textBlockSchema,
  d as useTextBlockContext,
  D as useTruncate
};
//# sourceMappingURL=index.es.js.map
